<template>
  <PaFrontForm
    class="pa-message-additional-box"
    :class="additionalFormClass"
    :action="'/'"
    :formSetClass="['form-set-primary']"
    :formSet="formSet"
    :submitText="'変更'"
    :submitLoading="isFormLoading"
    :isDisabledButton="isDisabledButton"
    :validationMessagePosition="'bottom'"

    :hasCancelButton="true"
    :cancelText="'やめる'"
    
    @handleSubmit="handleSubmit"
    @handleCancel="handleCancel"
  />
</template>

<script>
import FormValidationControlMixin from '@/mixins/FormValidationControlMixin.js'

import PaFrontForm from '@/components/FrontParts/PaFrontForm/PaFrontForm.vue'

export default {
  props : {
    isLoading   : {
      default: false,
    },

    isDisabled  : {
      default: false,
    },

    serverValidationError : {
      default: null
    },
  },

  mixins : [
    FormValidationControlMixin
  ],

  components : {
    PaFrontForm
  },

  data(){
    return {
      isFormLoading : false,

      formSet       : {
        email       : {
          label           : 'メールアドレス',
          validationRules : ['notEmpty', 'email', 'max'],
          inputType       : 'input',
          isDisabled      : false,
        }
      },

      isDisabledFormFields  : false,

      additionalFormClass : [],
    }
  },

  watch : {
    isDisabled  : {
      handler(value){
        if(value === true){
          this.isDisabledButton     = true;
          this.buttonClass          = ['button-disabled'];
          this.additionalFormClass  = ['pa-message-additional-box-disabled'];

          this.isDisabledFormFields = true;
        }else{
          this.isDisabledButton     = false;
          this.buttonClass          = [];
          this.additionalFormClass  = [];

          this.isDisabledFormFields = false;
        }
      },
      immediate: true
    },

    isLoading   : {
      handler(value){
        if(value === true){
          this.isFormLoading = true;
        }else{
          this.isFormLoading = false;
        }
      }
    },

    isFormLoading : {
      handler(value){
        this.isDisabledFormFields = value;
      }
    },

    isDisabledFormFields  : {
      handler(value){
        if(value === true){
          this.disabledFields();
        }else{
          this.unDisabledFields();
        }
      },
      immediate: true
    },

    serverValidationError : {
      handler(data){
        if(data === null) return;
        console.log(data);
        if(data.first.category === 'validation'){
          this.unValidateField({
            fieldName : data.first.field,
            message   : data.first.message,
          });
        }
      },
      immediate: true,
      deep:true
    }
  },

  methods : {
    handleSubmit(){
      if( this.checkFormPreValidation() ){
        this.$emit('onSubmit', this.formSet);
      }else{
        console.log('validation error');
      }
    },
    
    handleCancel(){
      this.$emit('onCancel');
    }
  }
}
</script>

<style lang="scss">
  @import "@/components/Pages/Office/MessageApp/MessageAppForm.scss";
</style>